export function ensurePageReload(url) {
  // We want to force a page reload on sign out because not all child applications unmount everything correctly
  // and they don't handle the global user and tenant changing.
  // For example, modals created by one child app but that are rendered by a different sofe service.
  // The only way I know of to force a reload when navigating to the same domain is to change the
  // protocol in the url. Since the load balancer auto-redirects from http -> https, this works.
  if (url.startsWith('https')) {
    return 'http' + url.slice('https'.length);
  } else {
    return url;
  }
}

